export const AUTH_TOKEN = 'ITRADE_ADMIN_AUTH_TOKEN';
